import * as React from 'react';
import { useTranslator } from '@gandi/translate';
import { Base, Pill } from '@gandi/ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ToggleMode = ({
  onToggle,
  mode
}) => {
  const {
    __
  } = useTranslator();
  return /*#__PURE__*/_jsxs(Base, {
    flex: true,
    flexWrap: true,
    flexAlignItemsBaseline: true,
    flexJustifyBetween: true,
    gap: "small",
    children: [/*#__PURE__*/_jsxs(Base, {
      flex: true,
      flexWrap: true,
      gap: "xsmall",
      children: [/*#__PURE__*/_jsx(Pill, {
        selected: mode === 'select',
        onClick: () => onToggle('select'),
        children: __('Select configuration')
      }), /*#__PURE__*/_jsx(Pill, {
        selected: mode === 'create',
        onClick: () => onToggle('create'),
        children: __('Create new configuration')
      })]
    }), mode === 'create' && /*#__PURE__*/_jsx(Base, {
      tagName: "p",
      margin: "none",
      color: "danger",
      children: __('* Required fields')
    })]
  });
};
export default ToggleMode;